import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import ChooseBg from "../../assets/images/how-to-contest.png";
import ChooseMainImg from "../../assets/images/choose-section-img.png";
import ContestIcons from "../../assets/icons/bzrp-cont-icons.png";

const sxStyles = {
  mainContainer: {
    backgroundImage: `url(${ChooseBg})`,
    alignItems: "center",
    display: "flex",
    backgroundSize: "cover",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    height: "550px",
  },
  staticCover: {
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: "1440px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    paddingTop: { xs: "70px", md: "190px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "18px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "18px", md: "20px" },
    textAlign: { xs: "center", md: "left" },
    maxWidth: { xs: "300px", md: "100%" },
    paddingRight: { xs: "20px", md: 0 },
    marginTop: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "32px", md: "45px" },
    fontWeight: "700",
    lineHeight: { xs: "33px", md: "70px" },
    marginRight: { xs: "13px", md: "13px", xl: "-10px" },
    paddingBottom: "5px",
    width: { xs: "90%", md: "27%" },
  },
  title: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "36px", md: "45px" },
    fontWeight: "400",
    lineHeight: { xs: "37px", md: "65px" },
    marginRight: "13px",
    width: "700px",
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const ChooseSection = () => {
  return (
    <Stack sx={sxStyles.mainContainer}>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignitems: "center",
          width: { xs: "350px", md: "800px" },
          marginBottom: "40px",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            marginTop: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
            }}
          >
            <Typography sx={sxStyles.p2Title}>BIZARRAPP</Typography>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Typography sx={sxStyles.title}>
                ELIGIRÁ UN MIXER GANADOR!
              </Typography>
            </Box>
            <Stack sx={{ display: { xs: "flex", md: "none" } }}>
              <Typography sx={sxStyles.title}>ELIGIRÁ UN</Typography>
              <Typography sx={sxStyles.title}>MIXER</Typography>
              <Typography sx={sxStyles.title}>GANADOR!</Typography>
            </Stack>
          </Grid>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <Typography sx={sxStyles.sectionText}>
              LO ANUNCIAREMOS EL 29/04 EN NUESTRAS REDES
            </Typography>
          </Box>
          <Stack sx={{ display: { xs: "flex", md: "none" } }}>
            <Typography sx={sxStyles.sectionText}>
              LO ANUNCIAREMOS EL 29/04
            </Typography>
            <Typography sx={sxStyles.sectionText}>EN NUESTRAS REDES</Typography>
          </Stack>
        </Stack>
      </Stack>
      <Box
        sx={{
          height: { xs: "180px", md: "360px" },
          display: "flex",
          backgroundImage: `url(${ChooseMainImg})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          width: { xs: "340px", md: "680px" },
          alignSelf: "center",
        }}
      />
    </Stack>
  );
};

export default ChooseSection;
